<template>
  <div v-if="isHamburgerDropdown">
    <el-dropdown-item
      v-for="action in processActionsButtons"
      :key="action.processId"
      :command="{ payload: action, type: 'action' }"
    >
      <span><i class="material-icons md-18 icon-align">play_arrow</i>{{ $i18n.t(action.name) }}</span>
    </el-dropdown-item>
    <el-drawer size="20%" :visible.sync="isConfirmOpen" :title="getTitle" direction="ttb" append-to-body>
      <div class="new-modal-content">
        <div class="new-modal-footer">
          <button type="button" class="el-button el-button--primary mt-4 ms-4" @click="onConfirm">
            <i></i>
            {{ $i18n.t('modal_confirm') }}
          </button>
        </div>
      </div>
    </el-drawer>
  </div>

  <el-dropdown
    v-else
    :title="$i18n.t('group_actions')"
    @command="setAction"
    :disabled="disabled"
    placement="bottom-start"
    trigger="click"
    class="default-hamburger el-button el-button--small is-plain"
  >
    <span class="el-dropdown-link">
      <span class="material-icons md-18">low_priority</span>
    </span>
    <el-dropdown-menu slot="dropdown">
      <el-dropdown-item v-for="action in processActionsButtons" :key="action.processId" :command="action">
        {{ $i18n.t(action.name) }}
      </el-dropdown-item>
    </el-dropdown-menu>
    <el-drawer size="20%" :visible.sync="isConfirmOpen" :title="getTitle" direction="ttb" append-to-body>
      <div class="new-modal-content">
        <div class="new-modal-body">
          {{ $i18n.t(confirmationText) }}
        </div>
        <div class="new-modal-footer">
          <button type="button" class="el-button el-button--primary mt-4 ms-4" @click="onConfirm">
            <i></i>
            {{ $i18n.t('modal_confirm') }}
          </button>
        </div>
      </div>
    </el-drawer>
  </el-dropdown>
</template>

<script>
import { cloneDeep, get, isEmpty, map } from 'lodash'
import operations from '../../../operations'
import EventBus from '../../../utils/event-bus'
import listRestMixin from '../../../utils/mixin-list-rest'
import notifyMixin from '../../../utils/mixin-notify'
import axios from '@/axiosClient';

export default {
  mixins: [listRestMixin, notifyMixin],
  props: {
    isHamburgerDropdown: {
      type: Boolean,
      default: false,
    },
    isModalOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      confirmationText: '',
    }
  },
  computed: {
    aggr() {
      return this.aggregations
        ? JSON.stringify(
            this.aggregations.reduce((accumulator, { column = '', aggr = 'Off' }) => {
              if (aggr !== 'Off') {
                accumulator.push({ column, aggr })
              }
              return accumulator
            }, []),
          )
        : []
    },
    aggregations() {
      return this.$get('aggregations')
    },
    availableInDetailView() {
      return this.$get('availableInDetailView')
    },
    controllerName() {
      return this.$get('controllerName')
    },
    getControllerName() {
      if (this.isInDashboard && !this.controllerName) {
        return
      }
      if (!this.controllerName && window.CORE && window.CORE.requestController && !this.isRelationshipList) {
        return window.CORE.requestController
      }
      return this.controllerName
    },
    disabled() {
      return !this.$get('areGroupActionsEnabled')
    },
    isConfirmOpen: {
      get() {
        return this.isModalOpen
      },
      set(value) {
        this.$emit('toggle-modal-open', value)
      },
    },
    isInDashboard() {
      return this.$get('isInDashboard')
    },
    isRelationshipList() {
      return this.$get('isRelationshipList')
    },
    getId() {
      return this.mongoList ? this.mongoList.collection.toLowerCase() : this.queryId || this.mongoId || this.rawSqlId || null
    },
    getTitle() {
      const rows =
        this.runGroupActionsOnAllWithoutSelect && isEmpty(this.selectedRows)
          ? this.recordsTotal
          : this.selectedRows.length
      return this.$i18n.interpolate(this.$i18n.t('are_you_sure_to_run_group_actions_on_rows: ${rows}'), { rows })
    },
    groupActionsRunning: {
      get() {
        return this.$get('groupActionsRunning')
      },
      set(groupActionsRunning) {
        this.$dispatch('setGroupActionsRunning', { groupActionsRunning })
      },
    },
    hiddenSearch() {
      return this.$get('hiddenSearch')
    },
    mongoId() {
      return this.$get('mongoId')
    },
    mongoList() {
      return this.$get('mongoList')
    },
    panelId() {
      return this.$get('panelId')
    },
    primaryKey() {
      return this.$get('primaryKey')
    },
    processActionsButtons() {
      const processActions = this.$get('processActionsButtons') || []
      return processActions.filter((action) => action.isBulk)
    },
    queryId() {
      return this.$get('queryId')
    },
    rawSqlId() {
      return this.$get('rawSqlId')
    },
    recordsTotal() {
      return this.$get('pager').total
    },
    runGroupActionsOnAllWithoutSelect() {
      return this.$get('runGroupActionsOnAllWithoutSelect')
    },
    selectedGroupAction() {
      return this.$get('selectedGroupAction')
    },
    searchParams() {
      return this.$get('searchParams')
    },
    selectedRows() {
      return this.$get('selectedRows')
    },
    selectedRowsFilter() {
      return this.$get('selectedRowsFilter')
    },
    u() {
      return this.$get('universalFilter')
    },
  },
  methods: {
    getFilteredModelIds() {
      const {
        aggr,
        availableInDetailView: columns,
        controllerName,
        hiddenSearch: hiddenSearchData,
        mongoId: formId,
        panelId,
        queryId,
        rawSqlId,
        selectedRows,
        selectedRowsFilter,
        u,
      } = this
      const search = cloneDeep(this.searchParams)
      delete search.start
      return this.$client.execute({
        operationId: 'List_getList',
        method: 'post',
        parameters: {
          aggr,
          columns,
          controllerName,
          formId,
          queryId,
          rawSqlId,
          hiddenSearchData,
          panelId,
          selectedRows,
          selectedRowsFilter,
          search,
          u: u.value || '',
          idOnly: true,
          showDetails: false,
          start: 0,
          length: this.recordsTotal,
        },
        requestContentType: 'application/x-www-form-urlencoded',
      })
    },
    noti(status) {
      let noty
      if (status !== 200) {
        noty = {
          text: 'groupAction_status_failure',
          type: 'error',
          duration: 10,
        }
      } else {
        noty = {
          text: 'groupAction_status_success',
          type: 'success',
        }
      }
      this.showNotification(noty)
    },
    onConfirm() {
      this.isConfirmOpen = false
      this.runGroupAction()
    },
    async runGroupAction() {
      this.groupActionsRunning = true
      let modelIDS
      if (this.runGroupActionsOnAllWithoutSelect && isEmpty(this.selectedRows)) {
        const list = await this.getFilteredModelIds()
        modelIDS = map(get(list, 'obj.data', []), this.primaryKey)
      } else {
        modelIDS = this.selectedRows
      }

      const postData = {
        id: this.selectedGroupAction,
        redirect: false,
        modelIDS
      }
      if (this.getId) {
        postData.listId = this.getId
      }

      const response = await axios({ method: 'post'})
        .then(instance => instance.post(`/api${operations.ProcessBuilder_runProcesses.path}`, postData, {
          responseType: 'blob'
        }))
        .catch(error => ({ error }))

      const contentDisposition = get(response, ['headers', 'content-disposition'])

      if (contentDisposition && contentDisposition.includes('attachment')) {
        const fileName = get(response, ['headers', 'content-disposition'], '').split('filename=')[1]
        const type = get(response, ['headers', 'content-type'], '')
        const blob = new Blob([response.data], { type })
        const url = window.URL.createObjectURL(blob)
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', fileName)
        document.body.appendChild(link)
        link.click()

        this.groupActionsRunning = false

        return true
      }

      this.groupActionsRunning = false
      this.noti(response.status)
      EventBus.$emit('refresh-layout')
    },
    setAction(action) {
      this.isConfirmOpen = true
      this.confirmationText = action.name
      this.$dispatch('setSelectedGroupAction', {
        processId: action.processId,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.grouped-hamburger {
  .el-dropdown-link {
    display: block;
    padding: 9px 15px;
  }
}
.icon-align {
  vertical-align: sub;
}
</style>
